/*
 * @Description: '产品中心'页面所有路由
 * @Author: 任录
 * @Date: 2019-07-22 16:50:00
 * @LastEditTime: 2019-07-26 16:48:59
*/

export default [
    {
        path: '/product',
        component: resolve => require(['@/views/product'], resolve),
        name: 'Product',
        meta: {
            nav: '产品中心'
        }
    },
/*  {
        path: 'product/:id',
        component: resolve => require(['@/views/product/detail'], resolve),
        name: 'Product_Detail',
        meta: {
            nav: '产品中心'
        }
    },*/

  {
    path: '/product1/data_manage',
    component: resolve => require(['@/views/product/data_manage'], resolve),
    name: 'Product_Detail',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: '/product1/data',
    component: resolve => require(['@/views/product/data'], resolve),
    name: 'data',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: '/product1/curve_edit',
    component: resolve => require(['@/views/product/curve_edit'], resolve),
    name: 'Product_Detail',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: '/product1/curve_edit',
    component: resolve => require(['@/views/product/curve_edit'], resolve),
    name: 'curve_edit',
    meta: {
      nav: '产品中心'
    }
  },
  //以下为隐藏页  首页点击属性
  {
    path: '/product02/data_manage',
    component: resolve => require(['@/views/product02/data_manage'], resolve),
    name: 'curve_edit',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: '/product02/data',
    component: resolve => require(['@/views/product02/data'], resolve),
    name: 'curve_edit',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: '/product02/curve_edit',
    component: resolve => require(['@/views/product02/curve_edit'], resolve),
    name: 'curve_edit',
    meta: {
      nav: '产品中心'
    }
  },
  /*{
    path: 'product1/jingLiuLan',
    component: resolve => require(['@/views/product/jingLiuLan'], resolve),
    name: 'jingLiuLan',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: 'product1/SanJiaoTu',
    component: resolve => require(['@/views/product/SanJiaoTu'], resolve),
    name: 'SanJiaoTu',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: 'product1/2DMoNi',
    component: resolve => require(['@/views/product/2DMoNi'], resolve),
    name: '2DMoNi',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: 'product1/DuanCeng',
    component: resolve => require(['@/views/product/DuanCeng'], resolve),
    name: 'DuanCeng',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: 'product1/TuoZhan',
    component: resolve => require(['@/views/product/TuoZhan'], resolve),
    name: 'TuoZhan',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: 'product/data_manage2',
    component: resolve => require(['@/views/product/data_manage2'], resolve),
    name: 'data_manage2',
    meta: {
      nav: '产品中心'
    }
  },
/*  {
    path: 'product1/data_manage',
    component: resolve => require(['@/views/product/detail'], resolve),
    name: 'chen2',
    meta: {
      nav: '产品中心'
    }
  },*/
]



// WEBPACK FOOTER //
// ./src/router/product.js